import { useEffect } from "react"

export function useTheme() {
  const themeInStorage = localStorage.getItem("theme")

  useEffect(() => {
    // Всегда тёмная тема по умолчанию если не выбрано вручную
    if (!themeInStorage) {
      localStorage.setItem("theme", "dark")
      document.documentElement.setAttribute("data-theme", "dark")
    } else {
      document.documentElement.setAttribute("data-theme", themeInStorage)
    }
  }, [])

  const onToggleTheme = () => {
    const current = localStorage.getItem("theme") || "dark"
    const next = current === "dark" ? "light" : "dark"
    localStorage.setItem("theme", next)
    document.documentElement.setAttribute("data-theme", next)
  }

  const isDarkTheme = (themeInStorage || "dark") === "dark"

  return { isDarkTheme, onToggleTheme }
}
